<template>
  <header class="header" :class="{ 'menu-open': mobMenuActive }">
    <div class="header__start">
      <strong class="logo">
        <!-- <a href="/" :style="{ 'background-image': cwsLogo }">CleanWEB</a> -->
        <a
          href="javascript:;"
          :style="{ backgroundImage: 'url(' + cwsLogo + ')' }"
          >CleanWEB</a
        >
      </strong>
      <div class="server-name">{{ $route.params.client_name }}</div>
    </div>
    <a
      @click="mobMenuActive = !mobMenuActive"
      href="javascript:;"
      class="burger"
      :class="{ active: mobMenuActive }"
    >
      <span></span>
    </a>
    <div class="content-box">
      <NavList />

      <LocaleSwitcher />

      <ul class="actions-list">
        <li>
          <a
            href="javascript:;"
            class="box"
            @click.prevent="showDetails = !showDetails"
          >
            <span class="ico"
              ><img src="@/assets/images/ico-user.png" alt="user"
            /></span>
            <span class="text" v-if="currentUser">{{
              currentUser.user.login
            }}</span>
          </a>

          <ul class="user-details" v-if="currentUser && showDetails">
            <li>
              <strong>Firstname</strong>
              <span>{{ currentUser.user.firstname }}</span>
            </li>
            <li>
              <strong>Lastname</strong>
              <span>{{ currentUser.user.lastname }}</span>
            </li>
            <li>
              <strong>Gender</strong>
              <span>{{ currentUser.user.title }}</span>
            </li>
          </ul>
        </li>
        <li>
          <div class="box">
            <span class="ico"
              ><img src="@/assets/images/ico-calendar.png" alt="calendar"
            /></span>
            <span class="text" v-if="currentUser.user.last_login">
              {{ $t("lastConnection") }}: <br />
              {{ lastConnectionFormat(currentUser.user.last_login) }}
            </span>
            <span class="text" v-else> {{ $t("firstConnection") }} </span>
          </div>
        </li>
        <li>
          <a href="javascript:;" @click.prevent="logOut" class="box">
            <span class="ico"
              ><img src="@/assets/images/ico-logout.png" alt="logout"
            /></span>
            <span class="text">Logout</span>
          </a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import NavList from "@/components/partials/NavList.vue";
import LocaleSwitcher from "@/components/partials/LocaleSwitcher.vue";
export default {
  name: "HeaderItem",
  components: {
    NavList,
    LocaleSwitcher,
  },
  data() {
    return {
      mobMenuActive: false,
      showDetails: false,
    };
  },
  watch: {
    $route() {
      if (this.mobMenuActive) {
        this.mobMenuActive = false;
      }
    },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      userOrganization: "getCurrentUserOrganization",
      cwsLogo: "getCwsLogo",
      cwsMotto: "getCwsMotto",
      serverParams: "getServerParams",
    }),
  },
  mounted() {
    document.addEventListener("click", this.onClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.onClick);
  },
  methods: {
    ...mapActions(["logOut"]),

    lastConnectionFormat(val) {
      return this.$moment(val).format("DD/MM/YYYY HH:MM:ss");
    },
    onClick(ev) {
      if (ev.target.closest(".actions-list li")) return;
      if (this.showDetails) {
        this.showDetails = false;
      }
      ev.stopPropagation();
    },
  },
};
</script>

<style lang="scss" scoped>
.burger {
  display: none;
  width: 50px;
  height: 50px;
  position: absolute;
  right: 12px;
  top: 50%;
  margin-top: -25px;
  z-index: 999;
  span {
    text-indent: -9999px;
    font-size: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    background-color: $color-dark;
    height: 2px;
    width: 25px;
    margin: -1px 0 0 -13px;
    &:after,
    &:before {
      content: "";
      background-color: $color-dark;
      height: 2px;
      width: 25px;
      left: 0;
      top: -9px;
      position: absolute;
      transition: transform 0.3s ease;
    }
    &:after {
      top: 9px;
    }
  }
  &.active {
    span {
      background-color: transparent;
      &:before {
        transform: rotate(45deg);
        top: 0;
        background-color: $color-dark;
      }
      &:after {
        transform: rotate(-45deg);
        background-color: $color-dark;
        top: 0;
      }
    }
  }

  @include breakpoint($mobile) {
    display: block;
  }
}

.server-name {
  padding: 0 0 0 15px;
}
.actions-list {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  li {
    display: inline-flex;
    border-right: 1px solid gray;
    position: relative;
    &:first-child {
      border-left: 1px solid gray;
    }
    &:last-child {
      border-right: none;
    }
  }
  .ico {
    margin-right: 4px;
  }
  .box {
    display: flex;
    align-items: center;
    padding: 7px;
    text-decoration: none;
    line-height: 16px;
    font-size: 12px;
    color: grey;
  }
  a.box {
    &:hover {
      .text {
        text-decoration: underline;
      }
    }
  }
  @include breakpoint($mobile) {
    display: block;
    padding-top: 15px;
    li {
      border-right: none !important;
      border-left: none !important;
      border-bottom: 1px solid gray;
      width: 100%;
      padding: 10px 10px;
    }
  }
}
.header {
  border: 1px solid gray;
  background: whitesmoke;
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
  &__start {
    display: flex;
    height: 100%;
    align-items: center;
  }
  @include breakpoint($mobile) {
    &.menu-open {
      .content-box {
        right: 0;
        opacity: 1;
        pointer-events: all;
      }
    }
  }
}
.content-box {
  flex: 1 1 auto;
  display: flex;
  justify-content: space-between;
  @include breakpoint($mobile) {
    display: block;
    position: absolute;
    top: calc(100% + 1px);
    left: auto;
    transition: all 0.35s ease 0s;
    background: $color-white;
    z-index: 100;
    width: 300px;
    padding: 25px 0;
    box-shadow: 0 8px 10px 1px #e0e0e0;
    border-top: 1px solid #e0e0e0;
    right: -300px;
    opacity: 0;
    pointer-events: none;
    border-radius: 0 0 0 15px;
  }
}
.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  // background: #4c4c4c;
  min-height: 100px;
  height: 100%;
  flex-direction: column;
  a {
    // background-image: url("../../assets/images/logo.png");
    background-image: var(data-image);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    width: 100%;
    height: 100%;
    display: block;
    text-indent: -9999px;
    flex: 1 1 auto;
  }
  // @include breakpoint($mobile) {
  //   width: 100%;
  //   max-width: 240px;
  //   padding: 10px;
  // }
}

.user-details {
  padding: 5px 10px;
  margin: 0;
  list-style: none;
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  width: 100%;
  min-width: 300px;
  z-index: 100;
  background: #fff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  li {
    display: flex;
    border: none !important;
    strong {
      padding-right: 5px;
      font-weight: bold;
      &:after {
        content: ":";
      }
    }
  }
}
</style>
